import Auth from "features/authentication/Auth";

export function useLogoutModal() {
  const handleLogout = () => {
    Auth.logout();
  };

  return { handleLogout };
}
